"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorePlansRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const store_1 = require("../../utils/store");
const styled_components_1 = __importStar(require("styled-components"));
function StorePlansRow({ benefit }) {
    const renderColumn = (licenseType) => {
        const valueString = (0, store_1.valueForBenefitAndLicenceTypes)(benefit, licenseType);
        if (valueString === store_1.BENEFIT_CHECK) {
            return (0, jsx_runtime_1.jsx)(Checkmark, { name: ui_1.Icons.Checkmark, "data-e2e": 'StorePlansRow_Checkmark' });
        }
        else if (valueString) {
            return (0, i18n_1.Localized)(valueString);
        }
        return null;
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { role: "row", "data-e2e": 'StorePlansRow_Container', children: [(0, jsx_runtime_1.jsx)(ColumnFirst, { role: "rowheader", "data-e2e": 'StorePlansRow_ColumnFirst', children: (0, i18n_1.Localized)((0, store_1.titleStringForBenefitType)(benefit)) }), (0, jsx_runtime_1.jsxs)(Columns, { "data-e2e": 'StorePlansRow_Columns', children: [(0, jsx_runtime_1.jsx)(Column, { role: "cell", "data-e2e": 'StorePlansRow_Column', children: renderColumn(bridge_schema_1.LicenseType.StudentPlus) }), (0, jsx_runtime_1.jsx)(Column, { role: "cell", "data-e2e": 'StorePlansRow_Column', children: renderColumn(bridge_schema_1.LicenseType.Pro) }), (0, jsx_runtime_1.jsx)(Column, { role: "cell", "data-e2e": 'StorePlansRow_Column', children: renderColumn(bridge_schema_1.LicenseType.Edu) })] })] }));
}
exports.StorePlansRow = StorePlansRow;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  width: 100%;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-direction: row;

    width: auto;
    height: 70px;

    border-bottom: 1px solid ${props => props.theme.backgroundQuinary};
  `)}
`;
const Column = styled_components_1.default.div `
  display: flex;
  flex-basis: 33.3%;
  align-items: center;
  justify-content: center;

  height: 100%;

  color: ${props => props.theme.greenSecondary};

  font-size: 16px;

  background-color: ${props => props.theme.store.columnHighlight};
`;
const ColumnFirst = styled_components_1.default.div `
  display: flex;
  align-items: center;

  height: 50px;

  padding: 0 0 0 20px;

  color: ${props => props.theme.text};

  font-size: 16px;

  background-color: ${props => props.theme.store.columnHighlight};

  border-bottom: 1px solid ${props => props.theme.backgroundQuinary};

  ${ui_1.device.tablet((0, styled_components_1.css) `
    padding: 0;

    min-width: 300px;
    height: 100%;

    background: none;
    border: none;
  `)}
`;
const Columns = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;

  height: 50px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    height: 70px;
  `)}
`;
const Checkmark = (0, styled_components_1.default)(ui_1.Icon).attrs({
    'aria-label': 'checkmark',
    role: 'img',
}) `
  width: 22px;
  height: 22px;

  margin: auto;

  color: ${props => props.theme.greenSecondary};
`;
